module.exports = __webpack_public_path__ + "img/stroke.c5999ee2.svg";